import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Wrapper, Indicator } from './styles';
export const Scroll = ({ itemCount, parentRef, visible }) => {
    const [{ dragging, offset }, setDragging] = useState({ dragging: false, offset: 0 });
    const elemRef = useRef(null);
    useEffect(() => {
        const scrollListener = () => {
            if (dragging) {
                return;
            }
            const { scrollHeight: parentScrollHeight, scrollTop: parentScrollTop, } = parentRef.current;
            const scrollPerc = parentScrollTop / parentScrollHeight;
            elemRef.current.style.top = `${scrollPerc * 100}%`;
        };
        parentRef.current.addEventListener('scroll', scrollListener);
        return () => {
            parentRef.current.removeEventListener('scroll', scrollListener);
        };
    }, [itemCount, dragging]);
    const startDragging = (e) => {
        const { top } = elemRef.current.getBoundingClientRect();
        setDragging({ dragging: true, offset: e.clientY - top });
    };
    const moveDragging = useCallback(e => {
        if (!dragging) {
            return;
        }
        const parentBounds = parentRef.current.getBoundingClientRect();
        const { height } = elemRef.current.getBoundingClientRect();
        const scrollTop = Math.min(parentBounds.height - height, Math.max(0, e.clientY - parentBounds.top - offset));
        elemRef.current.style.top = `${scrollTop}px`;
        const { scrollHeight: parentScrollHeight } = parentRef.current;
        const scrollPerc = scrollTop / parentBounds.height;
        const topOffset = parentScrollHeight * scrollPerc;
        if (parentRef.current.scrollTo) {
            parentRef.current.scrollTo(0, topOffset);
        }
        else {
            // eslint-disable-next-line no-param-reassign
            parentRef.current.scrollTop = topOffset;
        }
    }, [dragging]);
    const endDragging = () => {
        setDragging({ dragging: false, offset: 0 });
    };
    return (React.createElement(Wrapper, { visible: visible },
        React.createElement(Indicator, { onMouseMove: moveDragging, onMouseDown: startDragging, onMouseLeave: endDragging, onMouseUp: endDragging, itemCount: itemCount, ref: elemRef })));
};
//# sourceMappingURL=index.js.map